export const defaultTicket = () => {
    return {
        id:'',
        asunto:'',
        nombre:'',
        email:'',
        user_name: '',
        user_email: '',
        adjunto:'',
        mensaje:'',
        slq_locations_id: null,
        digit_location: false,
        ubicacion_diligenciada: '',
        type_matter: [],
        name_product: '',
        manufacturer_id: '',
        locations: '',
    }
}

export const defaultObservacion = () => {
    return {
        observacion:'',
        adjunto: '',
        id_ticket: 0,
        leido:0,
        fecha_leido:""
    }
}

export const defaultFiltroTicket = () => {
    return {
        ubicacion_diligenciada: '',
        slq_locations_id: null,
        digit_location: false,
        filtro: "",
        nombre: "",
        empresa: "",
        id_responsable: 0,
        asunto: "",
        email: "",
        estado: 0,
        profesional: 0,
        page: 1,
        perPage: 10,
        sortBy: 'id',
        sort: 'DESC',
        desde: "",
        hasta: "",
        type_matter: [],
        name_product: '',
        manufacturer_id: '',
        locations: '',
    }
}

export const defaultFiltroListas = () => {
    return {
        codigo: 'TCKMSJ',
        servicio: 'tickets/setMensajesMasivos',
        page: 1,
        perPage: 10,
        sort: 'DESC',
        sortBy: 'id'
    }
}

export const defaultTicketDetalle = () => {
    return {
        adjunto: null,
        asunto: "",
        color: "",
        email: "",
        empresa: "",
        estado: null,
        id: null,
        idTicket: "",
        id_empresa: null,
        id_responsable: null,
        location: null,
        mensaje: "",
        nombre: "",
        slq_locations_id: null,
        ubicacion_diligenciada: "",
        digit_location: false,
        created_at: "",
    }
}


export default {
    tickets: [],
    usuarios: [],
    estados: [],
    empresas:[],
    ticketsSeleccionados: [],
    estadosBusqueda: [],
    marcadosPagina: false,
    selectedTicket: defaultTicket(),
    selectedObservacion: defaultObservacion(),
    action: 'create',
    ticket_detalle: defaultTicketDetalle(),
    empresa: '',
    observaciones: [],
    filtroEt: defaultFiltroTicket(),
    vistoUsuario:{
        check:0,
        fecha: ""
    },
    filtrosListas: defaultFiltroListas(),
    pantalla: 'nuevoTicket',
    loading: true,
    esSuperAdmin: false,
    esAdmin: false,
    esEmpresa: false,
    mensajesMasivos: [],
    tickets_report: null,
    error: false,
    informesProcesados: [],
    tickets_chart: [],
    manufacturers: [],
    typesOfMatters: [
        {
            id: 1,
            label: 'Nuevo producto'
        },
        {
            id: 2,
            label: 'Actualizar producto'
        },
        {
            id: 3,
            label: 'Activar/Inactivar'
        },
        {
            id: 4,
            label: 'Otro'
        }
    ],
    selectedCompany: null
}
